import { Box } from '@/shared/ui/box/Box';
import { BoldHeadingPrimary } from '@/shared/ui/typography';
import { Section } from '@/widgets/game-section/ui/styles';
import { ConditionalWrapperGame } from '@/entities/game/ui/conditional-wrapper-game';
import { useI18n } from '@locales/client';

export const MobileSearchResult = ({items, onGameClick}) => {
  const t = useI18n();
  return (
    <>
      <Box $margin="0 0 14px">
        <BoldHeadingPrimary>
          {t('menu_banner.search_results')}
        </BoldHeadingPrimary>
      </Box>

      <Section $hasScroll={false}>
        {!!items?.length &&
          items.map((game) => (
            <ConditionalWrapperGame
              key={game.id}
              game={game}
              handleClickGame={onGameClick}
              hasScroll={false}
            />
          ))}
      </Section>
    </>
  );
}